import { PlusSquareIcon } from "@chakra-ui/icons";
import { Button, ButtonProps } from "@chakra-ui/react";

export function AddButton(props: ButtonProps) {
  return (
    <Button colorScheme="blue" leftIcon={<PlusSquareIcon />} size="sm" variant="ghost" {...props} />
  );
}
